
import { IndustryLayout } from "@/components/industry/IndustryLayout";
import { IndustryFAQ } from "@/components/industry/IndustryFAQ";
import { ServiceBusinessesHero } from "@/components/service-businesses/HeroSection";
import { BenefitsSection } from "@/components/service-businesses/BenefitsSection";
import { ServicesGrid } from "@/components/service-businesses/ServicesGrid";
import { SuccessStory } from "@/components/service-businesses/SuccessStory";
import { CTASection } from "@/components/service-businesses/CTASection";
import { industryFAQs } from "@/data/industry-faqs";

const ServiceBusinesses = () => {
  return (
    <IndustryLayout industryName="Service Businesses" className="bg-gradient-to-b from-blue-50 to-white">
      <ServiceBusinessesHero />
      <BenefitsSection />
      <ServicesGrid />
      <IndustryFAQ faqs={industryFAQs["service-businesses"]} industryName="Service Businesses" />
      <CTASection />
    </IndustryLayout>
  );
};

export default ServiceBusinesses;
